import '../../../../pages/Organization/OrganizationOld.scss';

import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

type Props = {
  isModalOn: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  selected: string[];
};

export const DeleteClassesModal = observer(({ isModalOn, setIsModalOn, selected }: Props) => {
  const { t } = useTranslation();
  const cs = useStores().classesStore;
    const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);
  

  const deleteClasses = useCallback(() => {
    selected.map((id) => {
      cs.deleteClassAndUpdate(id, selectedOrganizationId);
      setIsModalOn(false);
      return true;
    });
  }, [selected, cs, setIsModalOn, selectedOrganizationId]);

  return (
    <Modal
      open={isModalOn}
      onClose={() => setIsModalOn(false)}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => setIsModalOn(false),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => deleteClasses(),
      }}
      title={t('DeleteClass', { ns: 'classPage' })}
      titleIcon={<TrashIcon />}
      aria-labelledby={t('DeleteClass', { ns: 'classPage' })}
      aria-describedby={t('DeleteClassFromTheList', { ns: 'classPage' })}
    >
      <div className='modal-body'>
        <Paragraph>
          <>{t('AreYouSureYouWantPermanentlyDeleteThisClass', { ns: 'classPage' })}</>
        </Paragraph>
      </div>
    </Modal>
  );
});

export default DeleteClassesModal;
